import * as API from "middleware/api";

export const listRequest = () => API.executeWithAccessToken("/creditCards.list");
export const creditCardCacheIsInvalidatedRequest = () => API.executeWithAccessToken("/creditCard.cacheIsInvalidated.send");
export const revalidateCreditCardCacheRequest = () => API.executeWithAccessToken("/creditCard.revalidateCreditCardCache.send");
